import React from "react";

import TrainingPrograms from "../components/trainings/TrainingPrograms";
import TrainingIntro from "../components/trainings/TrainingIntro";
import TrainingHeroPage from "../components/trainings/TrainingHeroPage";
import TrainingForm from "../components/trainings/TrainingForm";
import heroImage from "../assets/images/hero-image-12-a.jpg";

const Trainings = () => {
  return (
    <section className="relative w-full min-h-screen text-white overflow-hidden">
      {/* FIXED BACKGROUND */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-[#091923]/75" />
      </div>

      {/* 🔥 CONTENT ABOVE BACKGROUND */}
      <div className="relative z-10">
        <TrainingHeroPage />    
        <TrainingIntro />
        <TrainingPrograms />
        <TrainingForm />
      </div>
    </section>
  );
};

export default Trainings;
